import React from "react";
import PropTypes from "prop-types";
import ReactInterval from "react-interval";
import "moment/locale/ru";
import Moment from "react-moment";
// import material-ui components
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import TablePagination from "@material-ui/core/TablePagination";
//import @material-ui/icons
import MoreIcon from "@material-ui/icons/MoreHoriz";
import AddIcon from "@material-ui/icons/Add";
import RestoreIcon from "@material-ui/icons/Restore";
//redux components
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
//import core components
import Button from "components/CustomButtons/Button.jsx";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Table from "components/Table/Table.jsx";
import NewMachineDialog from "components/Dialogs/NewMachineDialog";
import Danger from "components/Typography/Danger";
import ConfirmDeleteDialog from "components/Dialogs/ConfirmDeleteDialog";
import MachineWaterChangeDialog from "components/Dialogs/MachineWaterChangeDialog";
import ErrorDialog from "components/Dialogs/ErrorDialog";

import { history } from "../../history";
import { getErrorFromCode, getLastOrderFromTime, getWaterFromNumber, getWorkModeFromCode, getMachineRowColor } from "../../utils/misc";
import { get_machine_reset_refill } from "../../utils/http"

import usersStyle from "assets/jss/material-dashboard-react/views/usersStyle"

import * as actionCreators from "actions/machines";

function mapStateToProps(state) {
    return {
        token: state.auth.token,
        isMasterOrganization: state.auth.isMasterOrganization,
        machines: state.machines.machines,
        organizations: state.machines.organizations,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

class MachinesView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            machinesData: [],
            machineNewDialogIsOpened: false,
            timeoutEnabled: false,
            machinesRowPerPage: 100,
            machinesPage: 1,
            machinesResetRefillId: null,
            machinesResetRefillDialogOpen: false,
            machinesChangeWaterAmountDialogId: null,
            machinesChangeWaterAmountDialogValue: null,
            machinesChangeWaterAmountDialogIsOpened: false,
            errorDialogIsOpened: false,
        };
    }

    componentWillReceiveProps(nextProps, nextContext){
        const { classes } = this.props;
        this.setState((prevState) => ({
            ...prevState,
            machinesData: nextProps.machines.data.map((prop) => (
                [prop.id, prop.address, prop.cash || 0, prop.daily_sales_water, (<div className={classes.waterRefillDiv}>
                        <span>
                            {~~(prop.water_from_last_refill)}
                        </span>
                        <Button color="transparent"
                            className={classes.tableButton} onClick={() => this.machineChangeWaterAmountDialogOpen(prop.id,prop.water_from_last_refill)}>
                            изменить
                        </Button>
                    </div>),
                    prop.water_from_last_refill_machine,
                    prop.average_month_sales,
                    getWaterFromNumber(prop.water_amount),
                    prop.door_open ? <Danger>Открыта</Danger> : "Закрыта",
                    prop.temperature < 5 ? <Danger>{ prop.temperature }</Danger> : prop.temperature, prop.humidity && `${prop.humidity} %`,
                    getWorkModeFromCode(prop.work_mode),
                    getErrorFromCode(prop.error),
                    <Moment fromNow locale="ru">{prop.last_refill}</Moment>,
                    getLastOrderFromTime(prop.last_order_time),
                    <Moment fromNow locale="ru">{ prop.last_time }</Moment>,(<div>
                        <Button justIcon round simple color="transparent" className={classes.tableButton}
                                onClick={() => this.machineResetRefillDialogOpen(prop.id)}
                        >
                            <RestoreIcon/>
                        </Button>
                        <Button justIcon round simple color="transparent" className={classes.tableButton}
                                onClick={() => MachinesView.redirectToMachinePage(prop.id)}
                        >
                            <MoreIcon/>
                        </Button>
                    </div>
                )]
            )),
            machinesRowColor: nextProps.machines.data.map((prop) => (
                getMachineRowColor(prop)
            ))
        }))
    }

    componentDidMount(){
        this.setState({
            timeoutEnabled: true,
        });
        this.getData()
    }

    componentWillUnmount(){
        this.setState({
            timeoutEnabled: false,
        })
    }

    machineNewDialogOpen(){
        this.setState({
            machineNewDialogIsOpened: true,
        })
    }

    machineNewDialogClose(){
        this.setState({
            machineNewDialogIsOpened: false,
        })
    }

    createMachine(data){
        this.machineNewDialogClose();
        this.props.createMachine(this.props.token, data).then(r => {if (typeof r === typeof undefined) this.errorDialogOpen()});
    }

    static redirectToMachinePage(id){
        history.push(`/machines/${id}/`)
    }

    getData(){
        this.props.getMachines(this.props.token, this.state.machinesPage, this.state.machinesRowPerPage);
        this.props.getMachinesOrganizations(this.props.token);
    }

    handleMachinesChangePage(page){
        this.setState({
            machinesPage: page
        }, this.getData)
    }

    handleMachinesChangeRowsPerPage(e){
        if (e.target.value !== this.state.machinesRowPerPage) {
            this.setState({
                machinesRowPerPage: e.target.value
            }, this.getData);
        }
    }

    machineResetRefillDialogOpen(id){
        this.setState({
            machinesResetRefillId: id,
            machinesResetRefillDialogOpened: true,
        })
    }

    machineResetRefillDialogClose(){
        this.setState({
            machinesResetRefillId: null,
            machinesResetRefillDialogOpened: false,
        })
    }

    machineResetRefill(){
        get_machine_reset_refill(this.props.token, this.state.machinesResetRefillId);
        this.machineResetRefillDialogClose();
        this.getData();
    }

    machineChangeWaterAmountDialogOpen(id, water_amount){
        this.setState({
            machinesChangeWaterAmountDialogId: id,
            machinesChangeWaterAmountDialogValue: water_amount,
            machinesChangeWaterAmountDialogIsOpened: true,
        })
    }

    machineChangeWaterAmountDialogClose(){
        this.setState({
            machinesChangeWaterAmountDialogId: null,
            machinesChangeWaterAmountDialogValue: null,
            machinesChangeWaterAmountDialogIsOpened: false,
        })
    }

    machineChangeWaterAmount(water_amount){
        this.props.editMachine(this.props.token,{id: this.state.machinesChangeWaterAmountDialogId, water_from_last_refill: water_amount});
        this.machineChangeWaterAmountDialogClose();
        this.getData();
    }

    errorDialogOpen(){
        this.setState({
            errorDialogIsOpened: true,
        })
    }

    errorDialogClose(){
        this.setState({
            errorDialogIsOpened: false,
        })
    }

    render(){
        const { classes } = this.props;
        return (
            <div>
                <Card>
                    <CardHeader color="info">
                        <Grid container>
                            <GridItem xs={6} s={10} md={10}>
                                <h4>Автоматы</h4>
                            </GridItem>
                            <GridItem xs={6} s={2} md={2}>
                                <Button color="info" className={classes.headerButton} onClick={() => this.machineNewDialogOpen()}>
                                    <AddIcon className={classes.icons}/>Новый
                                </Button>
                            </GridItem>
                        </Grid>
                    </CardHeader>
                    <CardBody>
                        <Table
                            tableHead={["ID", "Адрес", "Касса", "Продано за сутки", "Продано с заправки", "Продано с заправки DWG", "Среднемес. продажи", "Датчик воды", "Состояние двери",
                                        "Темп.", "Влажность", "Режим", "Ошибка", "Время последней заправки", "Время последней покупки", "Последняя активность", ""]}
                            tableData={this.state.machinesData} size="small"
                            tableRowsColor={this.state.machinesRowColor}
                            tablePagination={(<TablePagination count={this.props.machines.count || 0}
                                                            onChangePage={(e, page) => this.handleMachinesChangePage(page + 1)}
                                                            page={this.state.machinesPage - 1} rowsPerPage={this.state.machinesRowPerPage}
                                                            labelDisplayedRows={({from, to, count}) => `${from}-${to} из ${count}`}
                                                            labelRowsPerPage="Строк на страницу:" component="div"
                                                            onChangeRowsPerPage={(e) => this.handleMachinesChangeRowsPerPage(e)}
                            />)}
                            />
                            <NewMachineDialog isOpened={this.state.machineNewDialogIsOpened}
                                              onSave={(machine) => this.createMachine(machine)}
                                              onCancel={() => this.machineNewDialogClose() }
                                              organizations={this.props.organizations.data}
                                              organizationEditable={this.props.isMasterOrganization}
                            />
                            <ConfirmDeleteDialog isOpened={this.state.machinesResetRefillDialogOpened}
                                                 onCancel={() => this.machineResetRefillDialogClose()}
                                                 onSave={() => this.machineResetRefill()}
                                                 buttonText="Сбросить" bodyText="Вы точно хотите сбросить время заправки?"/>
                            <MachineWaterChangeDialog isOpened={this.state.machinesChangeWaterAmountDialogIsOpened}
                                                      waterAmount={this.state.machinesChangeWaterAmountDialogValue}
                                                      onCancel={() => this.machineChangeWaterAmountDialogClose()}
                                                      onSave={(waterAmount) => this.machineChangeWaterAmount(waterAmount)}/>
                        </CardBody>
                </Card>
                <ErrorDialog onClose={() => this.errorDialogClose()} isOpened={this.state.errorDialogIsOpened}/>
                <ReactInterval timeout={15000} enabled={this.state.timeoutEnabled} callback={() => this.getData()}/>
            </div>
        )
    }
}

MachinesView.propTypes = {
    getMachines: PropTypes.func,
    getMachinesOrganizations: PropTypes.func,
    createMachine: PropTypes.func,
    editMachine: PropTypes.func,
    token: PropTypes.string,
    machinesIsLoaded: PropTypes.bool,
    organizations: PropTypes.shape({
        isLoaded: PropTypes.bool,
        isLoading: PropTypes.bool,
        data: PropTypes.array,
    }),
    machines: PropTypes.shape({
        isLoading: PropTypes.bool,
        isLoaded: PropTypes.bool,
        data: PropTypes.array,
        count: PropTypes.number,
        pages: PropTypes.number,
        page: PropTypes.number,
    }),
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(usersStyle)(MachinesView));


// WEBPACK FOOTER //
// ./src/views/Machines/Machines.jsx